import { FC, SVGAttributes } from 'react';

export const BznavRefundLogo: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="104" height="22" viewBox="0 0 104 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_13029_8654)">
        <path d="M103.218 1.83325H96.8184L103.218 8.23323V1.83325Z" fill="#707F8F" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M66.6781 12.0266C68.2823 11.9624 69.9048 11.8249 71.344 11.6324L71.4448 13.6491C68.0073 14.1258 63.2223 14.2266 59.3906 14.1808V12.1274H63.9098V10.7524C61.3523 10.0649 60.4173 7.22328 61.5081 5.20661H59.739V3.10744H63.9281V1.02661H66.7056V3.11661H70.849V5.21578H69.1348C70.2165 7.05828 69.4648 10.1749 66.6781 10.7799V12.0266ZM63.4056 7.06744C63.4056 8.12161 64.2673 8.97411 65.3215 8.97411C66.3756 8.97411 67.2281 8.13078 67.2281 7.06744C67.2281 6.00411 66.3848 5.15161 65.3215 5.15161C64.2581 5.15161 63.4056 6.01328 63.4056 7.06744Z"
          fill="#707F8F"
        />
        <path d="M75.029 8.70828H77.724V6.43494H75.029V1.61328H72.279V15.9316H75.029V8.70828Z" fill="#707F8F" />
        <path d="M62.6723 15.2349H65.4223V18.4066H75.5973V20.5241H62.6723V15.2349Z" fill="#707F8F" />
        <path
          d="M92.7481 9.16661C93.2065 7.05828 93.3531 4.31744 93.3531 2.00744H80.4923V4.15244H90.6031C90.6123 5.41744 90.4473 7.35161 90.1173 9.16661H78.4115V11.2933H95.5806V9.16661H92.7481Z"
          fill="#707F8F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M83.3706 14.3733H90.6215V12.2924H93.3715V20.5149H80.6206V12.2924H83.3706V14.3733ZM83.3706 18.3699H90.6215V16.3899H83.3706V18.3699Z"
          fill="#707F8F"
        />
        <path d="M15.29 1.46655H12.54V20.5333H15.29V1.46655Z" fill="#707F8F" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5725 7.24155H2.75V2.92405H0V15.3082H9.30417V2.92405H6.5725V7.24155ZM6.5725 13.0991H2.75V9.43239H6.5725V13.0991Z"
          fill="#707F8F"
        />
        <path d="M35.6767 16.1149H17.5817V18.3241H35.6767V16.1149Z" fill="#707F8F" />
        <path
          d="M18.9567 11.7057L20.5425 13.6216C22.7975 12.3566 24.8417 10.6057 26.3267 8.67156C28.2792 10.0557 30.2959 11.6507 32.3675 13.4474L34.0725 11.6141C32.0467 9.86322 29.7642 8.07573 27.6375 6.57239C27.9034 6.05906 28.1142 5.50906 28.2792 4.92239H33.0826V2.70406H20.1942V4.91322H25.4284C24.7409 7.25072 22.22 9.85406 18.9567 11.7057Z"
          fill="#707F8F"
        />
        <path d="M52.965 1.46655H50.3433V11.5774H52.965V1.46655Z" fill="#707F8F" />
        <path d="M46.2183 11.5774H48.8033V1.65905H46.2183V4.59239H42.4508V6.73739H46.2183V11.5774Z" fill="#707F8F" />
        <path
          d="M44.6233 8.46072C42.9825 8.71739 41.3692 8.84572 39.6917 8.83655V2.29155H36.9875V11.0091C39.5267 11.0274 42.4325 11.0091 44.8342 10.6057L44.6325 8.46072H44.6233Z"
          fill="#707F8F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.1782 14.5658H43.0741V12.5491H40.3241V20.5333H52.9282V12.5491H50.1782V14.5658ZM50.1691 18.425H43.0741V16.5825H50.1691V18.425Z"
          fill="#707F8F"
        />
      </g>
      <defs>
        <clipPath id="clip0_13029_8654">
          <rect width="103.583" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
